import React from "react"
import styles from "./FvVideoEngagement.module.scss"
import { IVideoMetrics } from "../types/types"

interface FvVideoEngagementProps {
  metrics?: IVideoMetrics
}

const formatRatePercent = (ratio: number): string => `${(ratio * 100).toFixed(1)}%`

const formatPercent = (percent: number): string => `${percent.toFixed(1)}%`

const formatCount = (value: number): string => value.toLocaleString("en-US")

const buildSegments = (metrics: IVideoMetrics): string[] => [
  `5s ${formatRatePercent(metrics.video5SecondViewRate)}`,
  `${formatCount(metrics.videoCompleteViews)} full`,
  `${formatCount(metrics.viewableImpressions)} viewable`,
]

const buildTitle = (metrics: IVideoMetrics): string =>
  [
    `5s view rate: ${formatRatePercent(metrics.video5SecondViewRate)} (${formatCount(metrics.video5SecondViews)} views)`,
    `Complete views: ${formatCount(metrics.videoCompleteViews)}`,
    `Viewable impressions: ${formatCount(metrics.viewableImpressions)} (${formatPercent(metrics.viewabilityRate)} viewable)`,
  ].join("\n")

const FvVideoEngagement: React.FC<FvVideoEngagementProps> = ({ metrics }) => {
  if (!metrics) {
    return null
  }

  return (
    <span className={styles.badge} title={buildTitle(metrics)} data-testid="fv-video-engagement">
      {buildSegments(metrics).map((segment, index) => (
        <React.Fragment key={segment}>
          {index > 0 && (
            <span aria-hidden="true" className={styles.separator}>
              ·
            </span>
          )}
          <span>{segment}</span>
        </React.Fragment>
      ))}
    </span>
  )
}

export default FvVideoEngagement
